import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

const EXCLUDED_ROUTES = [
  'b2c-callback',
  'login-b2c-callback',
  'login-entra-callback',
  'login',
  'logout',
  'ssoLoginV5',
];

@Injectable({
  providedIn: 'root'
})
export class RouterLinkBackService {
  private currentRoute: string | null = null;
  previousRoute: string | null = null;

  constructor(router: Router) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      filter(event => !EXCLUDED_ROUTES.includes(event.urlAfterRedirects))
    ).subscribe(event => {
      this.previousRoute = this.currentRoute;
      this.currentRoute = event.urlAfterRedirects;
    });
  }

}
